<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-10-10 15:04:35
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-10-10 15:45:16
 * @FilePath: \合联\oms\src\view\analysis\gccOrderStatistics\country.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/gccOrderStatistics";

export default {
  name: "",
  components: {
    cTable
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    headers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
    this.header.searchs.splice(
      0,
      0,
      ...this.headers.filter(t => t.key !== "statType")
    );
  },
  data() {
    return {
      methods: {
        ...apis,
        list(p) {
          return apis.country(p);
        },
        beforeHandleList({ data }) {
          return data;
        }
      },
      config: {
        isGetList: true
      },
      footer: {
        show: () => false
      },
      modals: {},
      header: {
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("详情,导出"),
              type: "detail",
              fnName: "detail",
              bind: {
                type: "primary"
              }
            }
          ],
          methods: {
            detail({ searchForm }) {
              this.handleRequestMethods(
                "list",
                Object.assign({ export: 1 }, searchForm),
                false,
                true
              ).then(res => {
                this.$Message.success(res.msg);
              });
            },
            export: () => {
              let table = this.$refs["table"];
              table.selectAll = table.list;
              table.exportExc(this.$t(this.$route.name) + "-" + this.name);
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$tz("国家"),
          key: "country",
          minWidth: 110
        },
        {
          name: () => this.$tz("地派"),
          key: "deliver",
          minWidth: 110
        },
        {
          name: () => this.$tz("COD"),
          children: [
            {
              name: () => this.$tz("发货量"),
              key: "cod_num",
              minWidth: 100
            },
            {
              name: () => this.$tz("签收"),
              key: "cod_pod_num",
              minWidth: 110
            },
            {
              name: () => this.$tz("签收率"),
              key: "cod_pod_rate",
              minWidth: 110
            }
          ]
        },
        {
          name: () => this.$tz("PP"),
          children: [
            {
              name: () => this.$tz("发货量"),
              key: "pp_num",
              minWidth: 100
            },
            {
              name: () => this.$tz("签收"),
              key: "pp_pod_num",
              minWidth: 110
            },
            {
              name: () => this.$tz("签收率"),
              key: "pp_pod_rate",
              minWidth: 110
            }
          ]
        },
        {
          name: () => this.$tz("Total"),
          children: [
            {
              name: () => this.$tz("发货量"),
              key: "num",
              minWidth: 100
            },
            {
              name: () => this.$tz("签收"),
              key: "pod_num",
              minWidth: 110
            },
            {
              name: () => this.$tz("签收率"),
              key: "pod_rate",
              minWidth: 110
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped></style>
